import React, { useState, useContext } from "react";
import { Fab, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateLinehaulFloating from "./CreateLinehaulFloating";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { roles, invoiceStatuses } from "../../Mappings";

const CreateLinehaulFab = (props) => {
  const [open, setOpen] = useState(false);
  const { userData } = useContext(UserDataContext);
  const disabled =
    !(
      userData.invoiceStatuses[props.truckId][props.week] === invoiceStatuses.unsubmitted ||
      userData.invoiceStatuses[props.truckId][props.week] === invoiceStatuses.dpcPending
    ) || userData.roleId === roles.tollManager;
  const onClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Create">
        <div>
          <Fab
            disabled={disabled}
            onClick={() => {
              setOpen(true);
            }}
            color="primary"
          >
            <AddIcon />
          </Fab>
        </div>
      </Tooltip>

      {open && <CreateLinehaulFloating {...props} onClose={onClose} />}
    </>
  );
};

export default CreateLinehaulFab;
